module.exports = __webpack_public_path__ + "img/s_4.1bf37487.jpg";